export default __webpack_public_path__ + "static/media/filled.ec892f49.svg";